import React, { FunctionComponent } from "react"

interface TemplatesCoffeeIconProps {}

const TemplatesCoffeeIcon: FunctionComponent<TemplatesCoffeeIconProps> =
  ({}) => {
    return (
      <svg
        width="67"
        height="65"
        viewBox="0 0 67 65"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_2398_2177)">
          <path
            d="M43 23.334H44.6667C46.4348 23.334 48.1305 24.0364 49.3807 25.2866C50.6309 26.5368 51.3333 28.2325 51.3333 30.0007C51.3333 31.7688 50.6309 33.4645 49.3807 34.7147C48.1305 35.9649 46.4348 36.6673 44.6667 36.6673H43"
            stroke="#ED7B2A"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M16.333 23.334H42.9997V38.334C42.9997 40.1021 42.2973 41.7978 41.0471 43.048C39.7968 44.2983 38.1011 45.0007 36.333 45.0007H22.9997C21.2316 45.0007 19.5359 44.2983 18.2856 43.048C17.0354 41.7978 16.333 40.1021 16.333 38.334V23.334Z"
            fill="#ED7B2A"
            stroke="#ED7B2A"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M23 11.666V16.666"
            stroke="#ED7B2A"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M29.667 11.666V16.666"
            stroke="#ED7B2A"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M36.333 11.666V16.666"
            stroke="#ED7B2A"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_2398_2177"
            x="-1"
            y="0"
            width="68"
            height="68"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feMorphology
              radius="2"
              operator="erode"
              in="SourceAlpha"
              result="effect1_dropShadow_2398_2177"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="8" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.929412 0 0 0 0 0.482353 0 0 0 0 0.164706 0 0 0 0.32 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_2398_2177"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_2398_2177"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    )
  }

export default TemplatesCoffeeIcon
